import React from "react";
import api from "@/lib/api";
import { Archive } from "lucide-react";
import { toast } from "sonner";

export function ArchiveButton({ url, label = "item ini", onDone, className = "", testid, size = "icon" }) {
  const run = async (e) => {
    e?.stopPropagation?.();
    if (!window.confirm(`Arsipkan ${label}? Item akan disembunyikan dari daftar.`)) return;
    try {
      await api.delete(url);
      toast.success("Diarsipkan");
      onDone?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Gagal mengarsipkan");
    }
  };
  if (size === "text") {
    return (
      <button onClick={run} data-testid={testid} className={`inline-flex items-center gap-1 text-xs font-semibold text-rose-500 hover:text-rose-700 ${className}`}>
        <Archive className="h-3.5 w-3.5" />Arsipkan
      </button>
    );
  }
  return (
    <button onClick={run} data-testid={testid}
      className={`inline-flex h-7 w-7 items-center justify-center rounded-lg text-slate-400 hover:bg-rose-50 hover:text-rose-600 transition-colors ${className}`}
      title="Arsipkan">
      <Archive className="h-4 w-4" />
    </button>
  );
}
